/** step2調査タブ */
export const STEP2_TAB = {
  neighboring: 'neighboring',
  falling: 'falling'
} as const
